import { styled } from '@mui/material';

import { LabelThemed } from '/shared/LabelThemed';

export const AppLabelStyled = styled(LabelThemed)`
  cursor: pointer;
`;
